import { abtastyService, cookieService, zarazService } from "@/services";
import axios from 'axios';
import {
  ACTIVE_DESIGN_DEFAULT,
  CUSTOMIZATION_DESIGN_CONVERT_DELETE_FAIL,
  CUSTOMIZATION_DESIGN_CONVERT_DELETE_REQUEST,
  CUSTOMIZATION_DESIGN_CONVERT_DELETE_SUCCESS,
  CUSTOMIZATION_DESIGN_CONVERT_FAIL,
  CUSTOMIZATION_DESIGN_CONVERT_REQUEST,
  CUSTOMIZATION_DESIGN_CONVERT_RESET,
  CUSTOMIZATION_DESIGN_CONVERT_SUCCESS,
  CUSTOMIZATION_DESIGN_UPLOAD_FAIL,
  CUSTOMIZATION_DESIGN_UPLOAD_REQUEST,
  CUSTOMIZATION_DESIGN_UPLOAD_SUCCESS,
  CUSTOMIZATION_FILTERS_UPDATE,
  CUSTOMIZATION_PDP_ITEM_FAIL,
  CUSTOMIZATION_PDP_ITEM_REQUEST,
  CUSTOMIZATION_PDP_ITEM_SET_INFO,
  CUSTOMIZATION_PDP_ITEM_SET_URL,
  CUSTOMIZATION_PDP_ITEM_SUCCESS,
  CUSTOMIZATION_PRODUCTS_LIST_SUCCESS,
  CUSTOMIZATION_REF_DATA_FAIL,
  CUSTOMIZATION_REF_DATA_REQUEST,
  CUSTOMIZATION_REF_DATA_SUCCESS,
  CUSTOMIZATION_SIDEBAR_FILTERS_UPDATE,
  CUSTOMIZATION_USER_DESIGN_DELETE_FAIL,
  CUSTOMIZATION_USER_DESIGN_DELETE_REQUEST,
  CUSTOMIZATION_USER_DESIGN_DELETE_SUCCESS,
  CUSTOMIZATION_USER_DESIGNS_FAIL,
  CUSTOMIZATION_USER_DESIGNS_REQUEST,
  CUSTOMIZATION_USER_DESIGNS_SUCCESS,
  CUSTOMIZATION_USER_DESIGNS_UPDATE_ACTIVE,
  CUSTOMIZATION_USER_SELCECTION_HISTORY_UPDATE_COLORS,
  CUSTOMIZATION_USER_SELCECTION_HISTORY_UPDATE_GRAPHIC_TYPES,
  GRAPHIC_TYPES_VALUES,
  QUOTE_SUMMARY_RESET,
  QUOTE_SUMMARY_UPDATE,
  SUBMIT_QUOTE_FAIL,
  SUBMIT_QUOTE_REQUEST,
  SUBMIT_QUOTE_SUCCESS,
} from '../constants/customization.constants';
import getPricingTier from '../utils/getPricingTier.util';
import { getRandomNumber } from '../utils/helper.util';
import { withGreToken } from '@utils/recaptcha';
// @ts-ignore
import { tryVectorizeImage, workers } from '@c2s-npm/plumreact';
import CookieNames from '@/constants/cookie-names.constants';
import { getCategorySlug, revertCategorySlug } from '@features/custom-shop/components/CategoryRouteGuard';
import {useTrackQuoteSubmitted} from "@features/custom-shop/hooks/useTrackQuote";
import { getPortalInfo, getPortalUrl } from '@utils/portal';
import { usePortalInfo } from '@hooks/usePortalInfo';
import { PDPActionTypes } from '@/constants/pdp.constants';

const sortOptions = (a, b) => a.sortOrder - b.sortOrder;

export const getRefData = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CUSTOMIZATION_REF_DATA_REQUEST });

    const { tag } = getPortalInfo();
    const url = jsRoutes.controllers.Customization.portalData(tag || "custom").url;
    const { data } = await axios.get(url);

    data.uoms = data.uoms.map((uom) => uom[1]);
    data.initialData.products = data.initialData.products.map((i) => {
      return {
        ...i,
        categoryId: data.categories.find((category) => i.categoryId === category.id),
        typeId: data.types.find((type) => i.typeId === type.id),
        sizeId: data.sizes.find((size) => i.sizeId === size.id),
        colorIds: i.colorIds.map((color) => data.colors.find((refColor) => color === refColor.id)),
      };
    });

    dispatch({ type: CUSTOMIZATION_REF_DATA_SUCCESS, payload: data });

    const categories = data.initialData.filterOptions.categories.map((category) => {
      return {
        category: data.categories.find((i) => i.id === category.id),
        count: category.count,
      };
    });

    const types = data.initialData.filterOptions.types.map((type) =>
      data.types.find((i) => i.id === type.id)
    );

    const sizes = data.initialData.filterOptions.sizes.map((size) =>
      data.sizes.find((i) => i.id === size.id)
    );

    const colors = data.initialData.filterOptions.colors
      .map((color) => data.colors.find((i) => i.id === color.id))
      .toSorted(sortOptions);

    const graphicTypes = data.initialData.filterOptions.graphicTypes.map((graphicType) => graphicType.id);

    dispatch({
      type: CUSTOMIZATION_SIDEBAR_FILTERS_UPDATE,
      payload: { colors, sizes, categories, graphicTypes, types },
    });

    filterByQueryString(false)(dispatch, getState);
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_REF_DATA_FAIL,
      payload: error.response || 'Failed fetching ref data',
    });
  }
};

export const filterByQueryString =
  (isPushState = false) =>
  (dispatch, getState) => {
    const newFiltersObj = {
      category: null,
      types: [],
      sizes: [],
      colors: [],
      graphicTypes: [], // color, engraved
      sortOrder: 'most-popular',
      search: '',
      isActive: false,
    };

    const refData = getState().customizationRefData;
    const queryParams: any = Object.fromEntries(new URLSearchParams(location.search).entries());

    const hasCategory = window.location.pathname.split('/').length > 3;
    let categoryExists = null;
    if (queryParams.category || hasCategory) {
      categoryExists = refData.categories.find((c) => {
        return (
          c.name.toLowerCase() === queryParams?.category?.toLowerCase() ||
          c.name.toLowerCase() === revertCategorySlug(window.location.pathname.split('/')?.[3])?.toLowerCase()
        );
      });

      if (categoryExists) newFiltersObj.category = categoryExists.id;
    }

    //* category id 9 === drinkwares
    if (queryParams.types && categoryExists.id === 9) {
      queryParams.types = queryParams.types.split(',');

      for (const type of queryParams.types) {
        const typeExists = refData.types.find((s) => s.value === type);

        if (typeExists && newFiltersObj.types.indexOf(typeExists.id) < 0)
          newFiltersObj.types.push(typeExists.id);
      }
    }

    if (queryParams.sizes) {
      queryParams.sizes = queryParams.sizes.split(',');

      for (const size of queryParams.sizes) {
        const sizeExists = refData.sizes.find((s) => s.value === size);

        if (sizeExists && newFiltersObj.sizes.indexOf(sizeExists.id) < 0)
          newFiltersObj.sizes.push(sizeExists.id);
      }
    }

    if (queryParams.colors) {
      queryParams.colors = queryParams.colors.split(',');

      for (const color of queryParams.colors) {
        const colorExists = refData.colors.find((c) => c.value === color);

        if (colorExists && newFiltersObj.colors.indexOf(colorExists.id) < 0)
          newFiltersObj.colors.push(colorExists.id);
      }

      dispatch({
        type: CUSTOMIZATION_USER_SELCECTION_HISTORY_UPDATE_COLORS,
        payload: [...new Set(newFiltersObj.colors)].reverse(),
      });
    }

    if (queryParams.graphicTypes) {
      if (queryParams.graphicTypes) queryParams.graphicTypes = queryParams.graphicTypes.split(',');

      for (const graphicType of queryParams.graphicTypes) {
        if (
          GRAPHIC_TYPES_VALUES.findIndex((i) => i.value === graphicType) >= 0 &&
          newFiltersObj.graphicTypes.indexOf(graphicType) < 0
        )
          newFiltersObj.graphicTypes.push(graphicType);

        dispatch({
          type: CUSTOMIZATION_USER_SELCECTION_HISTORY_UPDATE_GRAPHIC_TYPES,
          payload: [...new Set(newFiltersObj.graphicTypes)].reverse(),
        });
      }
    }

    if (queryParams.sortOrder) newFiltersObj.sortOrder = queryParams.sortOrder;

    filterProducts(newFiltersObj, isPushState)(dispatch, getState);
  };

export const filtersAdd = (key, val) => (dispatch, getState) => {
  let newFiltersObj = { ...getState().filters };
  if (key === 'category') {
    newFiltersObj = {
      ...newFiltersObj,
      colors: [],
      sizes: [],
      types: [],
      graphicTypes: [],
      category: val,
    };
  } else if (key === 'colors' || key === 'sizes' || key === 'graphicTypes' || key === 'types') {
    const newArr = newFiltersObj[key].concat(val);
    newFiltersObj[key] = [...new Set(newArr)];
  } else if (key === 'sortOrder' || key === 'search') {
    newFiltersObj[key] = val;
  } else {
    console.error('Unknown filter key');
    return;
  }

  filterProducts(newFiltersObj, true)(dispatch, getState);
  if (key !== 'search') {
    const productsListOffset =
      window.pageYOffset + document.getElementById('productsListHeader').getBoundingClientRect().top || 130;
    window.scrollTo(0, productsListOffset - 130);
  }
};

export const filtersRemove = (key, val) => (dispatch, getState) => {
  let newFiltersObj = { ...getState().filters };
  if (key === 'category') {
    newFiltersObj = {
      ...newFiltersObj,
      colors: [],
      sizes: [],
      types: [],
      category: null,
    };
  } else if (key === 'colors' || key === 'sizes' || key === 'graphicTypes' || key === 'types') {
    const valIndex = newFiltersObj[key].indexOf(val);
    if (valIndex >= 0) {
      newFiltersObj[key] = [...newFiltersObj[key]].splice(valIndex, 1);
    }
  } else {
    console.error('Unknown filter key');
    return;
  }

  filterProducts(newFiltersObj, true)(dispatch, getState);
  const productsListOffset =
    window.pageYOffset + document.getElementById('productsListHeader').getBoundingClientRect().top || 130;
  window.scrollTo(0, productsListOffset - 130);
};

export const filterProducts =
  (filterOptions, isPushState = false) =>
  (dispatch, getState) => {
    let products = getState().customizationRefData.initProducts || [];
    let categoryProducts = products;
    let sidebarFilters = getState().sidebarFilters;

    if (filterOptions.search) {
      products = products.filter((i) =>
        i.displayName.toLowerCase().includes(filterOptions.search.toLowerCase())
      );
    }

    if (filterOptions.category) {
      products = products.filter((i) => i.categoryId?.id === filterOptions.category);
      categoryProducts = [...products];
    }

    if (filterOptions.types.length > 0) {
      products = products.filter((i) => i.typeId && filterOptions.types.indexOf(i.typeId.id) >= 0);
    }

    if (filterOptions.sizes.length > 0) {
      products = products.filter((i) => i.sizeId && filterOptions.sizes.indexOf(i.sizeId.id) >= 0);
    }

    if (filterOptions.graphicTypes.length > 0) {
      products = products.filter((i) =>
        i.graphicTypes.some((graphicType) => filterOptions.graphicTypes.indexOf(graphicType) >= 0)
      );
    }

    if (filterOptions.colors.length > 0) {
      products = products.filter((i) =>
        i.colorIds.some((color) => filterOptions.colors.indexOf(color.id) >= 0)
      );
    }

    products = products.map((product) => {
      return {
        ...product,
        items: product.items.toSorted(sortOptions),
      };
    });

    switch (filterOptions.sortOrder) {
      case 'a-to-z':
        products = products.toSorted((a, b) =>
          a.displayName < b.displayName ? -1 : a.displayName > b.displayName ? 1 : 0
        );
        break;

      case 'z-to-a':
        products = products.toSorted((a, b) =>
          a.displayName < b.displayName ? 1 : a.displayName > b.displayName ? -1 : 0
        );
        break;

      case 'price-high-to-low':
        products = products.toSorted((a, b) => b.minRate - a.minRate);
        break;

      case 'price-low-to-high':
        products = products.toSorted((a, b) => a.minRate - b.minRate);
        break;

      default:
        // most-popular
        break;
    }

    sidebarFilters = {
      ...sidebarFilters,
      ...getSidebarFilters(categoryProducts, products, filterOptions),
    };

    filterOptions.isActive =
      filterOptions.search?.trim() ||
      filterOptions.colors.length > 0 ||
      filterOptions.types.length > 0 ||
      filterOptions.sizes.length > 0 ||
      filterOptions.graphicTypes.length > 0 ||
      filterOptions.category !== null;

    if (isPushState) {
      const filtersUrl = getFiltersUrl(filterOptions, getState().customizationRefData);
      // TODO this is creating complications
      // window.history.pushState({}, null, filtersUrl);
    }

    dispatch({
      type: CUSTOMIZATION_FILTERS_UPDATE,
      payload: filterOptions,
    });

    dispatch({
      type: CUSTOMIZATION_PRODUCTS_LIST_SUCCESS,
      payload: {
        products,
      },
    });

    dispatch({
      type: CUSTOMIZATION_SIDEBAR_FILTERS_UPDATE,
      payload: sidebarFilters,
    });
  };

export const getFiltersUrl = (filterOptions, refData) => {
  const url = [];
  // let categoryPath = '/custom/prices';
  const { tag } = getPortalInfo();
  let categoryPath = jsRoutes.controllers.Customization.portalShop(tag || "custom").url

  if (filterOptions.category && refData.categories && refData.categories.length > 0) {
    const categoryName =
      refData.categories.find((i) => i.id === filterOptions.category)?.name || filterOptions.category;
    categoryPath += `/${getCategorySlug(categoryName)}`;
  }

  if (filterOptions.types.length > 0 && refData.types && refData.types.length > 0) {
    const types = [];
    for (const type of filterOptions.types) {
      const typeName = refData.types.find((i) => i.id === type)?.value || type;
      types.push(encodeURIComponent(typeName));
    }
    url.push(`types=${types.join(',')}`);
  }

  if (filterOptions.sizes.length > 0 && refData.sizes && refData.sizes.length > 0) {
    const sizes = [];
    for (const size of filterOptions.sizes) {
      const sizeValue = refData.sizes.find((i) => i.id === size)?.value || size;
      sizes.push(encodeURIComponent(sizeValue));
    }
    url.push(`sizes=${sizes.join(',')}`);
  }

  if (filterOptions.colors.length > 0 && refData.colors && refData.colors.length > 0) {
    const colors = [];
    for (const color of filterOptions.colors) {
      const colorValue = refData.colors.find((i) => i.id === color)?.value || color;
      colors.push(encodeURIComponent(colorValue));
    }
    url.push(`colors=${colors.join(',')}`);
  }

  if (filterOptions.graphicTypes.length > 0) {
    const encodedGraphicTypes = [];
    for (const graphicType of filterOptions.graphicTypes) {
      encodedGraphicTypes.push(encodeURIComponent(graphicType));
    }
    url.push(`graphicTypes=${encodeURIComponent(encodedGraphicTypes.join(','))}`);
  }

  return `${categoryPath}${url.length > 0 ? `?${url.join('&')}` : ''}`;
};

const getSidebarFilters = (categoryProducts, products, selectedFilters) => {
  let types = [];
  let sizes = [];
  let colors = [];
  let graphicTypes = [];

  for (const product of products) {
    types.push(product.typeId);
    sizes.push(product.sizeId);
    colors.push(...product.colorIds);
    graphicTypes.push(...product.graphicTypes);
  }

  const filteredCategoryProducts = categoryProducts.filter(
    (product) =>
      selectedFilters.graphicTypes.some((graphicType) => product?.graphicTypes?.indexOf(graphicType) >= 0) ||
      selectedFilters.colors.some((colorId) => product?.colorIds?.find((color) => color?.id === colorId)) ||
      selectedFilters.sizes.some((sizeId) => product?.sizeId?.id === sizeId)
  );

  for (const product of filteredCategoryProducts) {
    types.push(product.typeId);
  }

  for (const product of categoryProducts.filter(
    (product) =>
      selectedFilters.graphicTypes.some((graphicType) => product.graphicTypes.indexOf(graphicType) >= 0) ||
      selectedFilters.colors.some((colorId) => product.colorIds.find((color) => color.id === colorId)) ||
      selectedFilters.types.some((typeId) => product.typeId.id === typeId)
  )) {
    sizes.push(product.sizeId);
  }

  graphicTypes = [...new Set(graphicTypes)];
  colors = [...new Set(colors)].toSorted(sortOptions);
  types = [
    ...new Set(
      selectedFilters.colors.length > 0 ||
      selectedFilters.graphicTypes.length > 0 ||
      selectedFilters.sizes.length > 0
        ? types
        : categoryProducts.map((p) => p.typeId)
    ),
  ].toSorted(sortOptions);
  sizes = [
    ...new Set(
      selectedFilters.colors.length > 0 ||
      selectedFilters.graphicTypes.length > 0 ||
      selectedFilters.types.length > 0
        ? sizes
        : categoryProducts.map((p) => p.sizeId)
    ),
  ].toSorted(sortOptions);

  for (const colorId of selectedFilters.colors) {
    const colorCopyId = colors.findIndex((i) => i.id === colorId);

    if (colorCopyId >= 0) {
      const colorCopyValue = colors[colorCopyId];
      colors.splice(colorCopyId, 1);
      colors.unshift(colorCopyValue);
    }
  }

  for (const typeId of selectedFilters.types) {
    const typeCopyId = types.findIndex((i) => i.id === typeId);

    if (typeCopyId >= 0) {
      const typeCopyValue = types[typeCopyId];
      types.splice(typeCopyId, 1);
      types.unshift(typeCopyValue);
    }
  }

  for (const sizeId of selectedFilters.sizes) {
    const sizeCopyId = sizes.findIndex((i) => i.id === sizeId);

    if (sizeCopyId >= 0) {
      const sizeCopyValue = sizes[sizeCopyId];
      sizes.splice(sizeCopyId, 1);
      sizes.unshift(sizeCopyValue);
    }
  }

  return {
    sizes,
    graphicTypes,
    colors,
    types,
  };
};

export const updateColorSelectionHistory =
  (color, isRemove = false) =>
  (dispatch, getState) => {
    const oldColors = getState().userSelectionHistory.colors;
    const colors = isRemove ? [...oldColors.filter((i) => i !== color)] : [color, ...oldColors];
    dispatch({
      type: CUSTOMIZATION_USER_SELCECTION_HISTORY_UPDATE_COLORS,
      payload: [...new Set(colors)],
    });
  };

export const updateGraphicTypesSelectionHistory =
  (graphicType, isRemove = false) =>
  (dispatch, getState) => {
    const oldGraphicTypes = getState().userSelectionHistory.graphicTypes;
    const graphicTypes = isRemove
      ? [...oldGraphicTypes.filter((i) => i !== graphicType)]
      : [graphicType, ...oldGraphicTypes];
    dispatch({
      type: CUSTOMIZATION_USER_SELCECTION_HISTORY_UPDATE_GRAPHIC_TYPES,
      payload: [...new Set(graphicTypes)],
    });
  };

export const userDesignSelection = (design) => async (dispatch) => {

  const isSvg = !!design.mimetype.match(/image\/svg/);

  dispatch({
    type: CUSTOMIZATION_USER_DESIGNS_UPDATE_ACTIVE,
    payload: design,
  });

  if (!isSvg) {
    workers.vectorize({
      url: design.url,
      onSuccess: ({ vectorized, ...e}) => {
        dispatch({
          type: CUSTOMIZATION_USER_DESIGNS_UPDATE_ACTIVE,
          payload: Object.assign({}, design, { vectorized }),
        });
      },
    });
  }

  cookieService.set(CookieNames.CUSTOM_DESIGN_ACTIVE, design.id);
};

export const userDesignVectorized = (design, vectorized, vectorizeMethod) => async (dispatch) => {
  dispatch({
    type: CUSTOMIZATION_USER_DESIGNS_UPDATE_ACTIVE,
    payload: Object.assign({}, design, { vectorized, vectorizeMethod }),
  });
};

export const uploadDesign = (design) => async (dispatch, getState) => {
  try {
    dispatch({ type: CUSTOMIZATION_DESIGN_UPLOAD_REQUEST });

    const formData = new FormData();
    formData.append('file', design);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    const { data } = await axios.post(`/custom/designs`, formData, config);

    dispatch({
      type: CUSTOMIZATION_DESIGN_UPLOAD_SUCCESS,
    });

    dispatch({
      type: CUSTOMIZATION_USER_DESIGNS_SUCCESS,
      payload: [...getState().userDesigns.designs, data[0]],
    });

    dispatch(userDesignSelection(data[0]));
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_DESIGN_UPLOAD_FAIL,
      payload: 'Failed uploading design, please try again.',
    });
  }
};

export const convertDesign = (design) => async (dispatch) => {
  try {
    dispatch({ type: CUSTOMIZATION_DESIGN_CONVERT_REQUEST });

    const formData = new FormData();
    formData.append('file', design);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    const { data } = await axios.post(`/custom/designs`, formData, config);

    console.log(data);

    dispatch({
      type: CUSTOMIZATION_DESIGN_CONVERT_SUCCESS,
      payload: data[0],
    });
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_DESIGN_CONVERT_FAIL,
      payload: 'Failed converting design, please try again.',
    });
  }
};

export const confirmConvertedDesign = () => (dispatch, getState) => {
  dispatch({
    type: CUSTOMIZATION_USER_DESIGNS_SUCCESS,
    payload: [...getState().userDesigns.designs, getState().designsConvert.design],
  });

  dispatch(userDesignSelection(getState().designsConvert.design));

  dispatch({ type: CUSTOMIZATION_DESIGN_CONVERT_RESET });

  dispatch({
    type: CUSTOMIZATION_DESIGN_UPLOAD_SUCCESS,
  });
};

export const deleteConvertedDesign = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CUSTOMIZATION_DESIGN_CONVERT_DELETE_REQUEST });

    const { data } = await axios.delete(`/custom/designs/${getState().designsConvert.design.id}`);

    dispatch({ type: CUSTOMIZATION_DESIGN_CONVERT_DELETE_SUCCESS });

    dispatch({ type: CUSTOMIZATION_DESIGN_CONVERT_RESET });
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_DESIGN_CONVERT_DELETE_FAIL,
      payload: 'Failed deleting design',
    });
  }
};

export const deleteDesign = (fileId) => async (dispatch) => {
  try {
    dispatch({ type: CUSTOMIZATION_USER_DESIGN_DELETE_REQUEST });

    const { data } = await axios.delete(`/custom/designs/${fileId}`);

    dispatch({ type: CUSTOMIZATION_USER_DESIGN_DELETE_SUCCESS });

    dispatch({
      type: CUSTOMIZATION_USER_DESIGNS_SUCCESS,
      payload: data,
    });

    dispatch(userDesignSelection(data.length > 0 ? data[data.length - 1] : ACTIVE_DESIGN_DEFAULT));
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_USER_DESIGN_DELETE_FAIL,
      payload: error.response?.message || error.response || 'Failed deleting design',
    });
  }
};

export const getUserDesignsList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CUSTOMIZATION_USER_DESIGNS_REQUEST });

    const portal = getPortalInfo()
    const url = portal.isPortal ? jsRoutes.controllers.Customization.portalDesigns(portal.tag).url : jsRoutes.controllers.Customization.listDesigns().url;
    const { data } = await axios.get(url);

    dispatch({
      type: CUSTOMIZATION_USER_DESIGNS_SUCCESS,
      payload: data,
    });

    if (data.length > 0 && getState().userDesigns.active.id === -1) {
      const qs = Object.fromEntries(new URLSearchParams(window.location.search).entries());
      const fileId = parseInt(qs.fileId || cookieService.get(CookieNames.CUSTOM_DESIGN_ACTIVE));

      const design = data.find((d) => d.id === fileId) || data[data.length - 1];
      dispatch(userDesignSelection(design));
    }
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_USER_DESIGNS_FAIL,
      payload: error.response?.message || error.response || 'Failed fetching user designs',
    });
  }
};

export const fetchCustomShopItem = (url) => async (dispatch) => {
  try {
    if (url && url !== '#') {
      dispatch({ type: CUSTOMIZATION_PDP_ITEM_REQUEST });

      const portalUrl = getPortalUrl(url);
      const { data } = await axios.get(portalUrl);
      window.history.replaceState({}, null, portalUrl);

      dispatch({ type: PDPActionTypes.SUCCESS, payload: data.jsonItem || data });
      setCustomShopItem(data.jsonItem || data)(dispatch);
    } else {
      console.log('URL was empty');
    }
  } catch (error) {
    dispatch({
      type: CUSTOMIZATION_PDP_ITEM_FAIL,
      payload: error.response || 'Failed fetching item, falling back',
    });
    fetchCustomShopItemFallback(url, error, 2);
  }
};

export const setCustomShopInfo = (data) => {
  return {
    type: CUSTOMIZATION_PDP_ITEM_SET_INFO,
    payload: data,
  };
};

function fetchCustomShopItemFallback(url, response, refCode = 0) {
  console.error(`An error occured during the request, error (${refCode}): `, response);
  console.error('Redirecting to: ', url);
  window.location.href = url;
}

export const setCustomShopItem =
  (data, fromRoot = false) =>
  (dispatch) => {
    fromRoot && document.querySelector('#customization-module').removeAttribute('data-item');

    dispatch({
      type: CUSTOMIZATION_PDP_ITEM_SUCCESS,
      payload: data,
    });
  };

export const setSelectedItemUrl = (url) => (dispatch) => {
  dispatch({
    type: CUSTOMIZATION_PDP_ITEM_SET_URL,
    payload: url,
  });
};

export const updateQuoteSummaryItem = (quoteItem) => (dispatch, getState) => {
  const quoteSummary = { ...getState().quoteSummary };
  quoteSummary.items = [...quoteSummary.items]; // Avoid mutating original array when items are added/removed later

  const oldQuoteItemIdx = quoteSummary.items.findIndex((i) => i.id === quoteItem.id);
  if (oldQuoteItemIdx < 0) throw new Error('Quote item not found');

  quoteSummary.items.splice(oldQuoteItemIdx, 1);

  const itemIndex = quoteSummary.items.findIndex(
    (i) =>
      (!!i?.customizationOptions?.designId &&
        i?.customizationOptions?.designId === quoteItem?.customizationOptions?.designId) ||
      (i.item.id === quoteItem.item.id &&
        i?.design?.id === quoteItem?.design?.id &&
        i?.customizationOptions?.addText === quoteItem?.customizationOptions?.addText &&
        i?.customizationOptions?.customizeOtherSide === quoteItem?.customizationOptions?.customizeOtherSide &&
        i?.customizationOptions?.remarks === quoteItem?.customizationOptions?.remarks &&
        i?.customizationOptions?.graphicType === quoteItem?.customizationOptions?.graphicType)
  );

  if (itemIndex >= 0) {
    const quantity = quoteSummary.items[itemIndex].quantity + quoteItem.quantity;
    quoteSummary.items[itemIndex] = Object.assign({}, quoteSummary.items[itemIndex], quoteItem, { quantity });
  } else {
    quoteSummary.items.unshift(quoteItem);
  }

  const { totalPrice, totalItems } = getQuoteSummaryTotal(quoteSummary);
  quoteSummary.totalPrice = totalPrice;
  quoteSummary.totalItems = totalItems;

  dispatch({
    type: QUOTE_SUMMARY_UPDATE,
    payload: quoteSummary,
  });

  localStorage.setItem('quoteSummary', JSON.stringify(getState().quoteSummary));
};

export const addQuoteSummaryItem = (quoteItem) => (dispatch, getState) => {
  const quoteSummary = { ...getState().quoteSummary };
  quoteSummary.items = [...quoteSummary.items]; // Avoid mutating original array when items are added/removed later

  let idExists = quoteSummary.items.findIndex((i) => i.id === quoteItem.id);
  while (idExists >= 0) {
    quoteItem.id = getRandomNumber();
    idExists = quoteSummary.items.findIndex((i) => i.id === quoteItem.id);
  }

  const itemIndex = quoteSummary.items.findIndex(
    (i) =>
      (!!i?.customizationOptions?.designId &&
        i?.customizationOptions?.designId === quoteItem?.customizationOptions?.designId) ||
      (i.item.id === quoteItem.item.id &&
        i?.design === quoteItem?.design &&
        i?.customizationOptions?.addText === quoteItem?.customizationOptions?.addText &&
        i?.customizationOptions?.customizeOtherSide === quoteItem?.customizationOptions?.customizeOtherSide &&
        i?.customizationOptions?.remarks === quoteItem?.customizationOptions?.remarks &&
        i?.customizationOptions?.graphicType === quoteItem?.customizationOptions?.graphicType &&
        i?.customizationOptions?.printType === quoteItem?.customizationOptions?.printType)
  );

  if (itemIndex >= 0) {
    const quantity = quoteSummary.items[itemIndex].quantity + quoteItem.quantity;
    quoteSummary.items[itemIndex] = Object.assign({}, quoteSummary.items[itemIndex], quoteItem, { quantity });
  } else {
    quoteSummary.items.unshift(quoteItem);
  }

  const { totalPrice, totalItems } = getQuoteSummaryTotal(quoteSummary);
  quoteSummary.totalPrice = totalPrice;
  quoteSummary.totalItems = totalItems;

  dispatch({
    type: QUOTE_SUMMARY_UPDATE,
    payload: quoteSummary,
  });

  localStorage.setItem('quoteSummary', JSON.stringify(getState().quoteSummary));
};

export const removeQuoteSummaryItem = (quoteItemId) => (dispatch, getState) => {
  const quoteSummary = { ...getState().quoteSummary };
  quoteSummary.items = [...quoteSummary.items]; // Avoid mutating original array when items are added/removed later

  const itemIndex = quoteSummary.items.findIndex((i) => i.id === quoteItemId);

  if (itemIndex < 0) {
    console.log("Quote item doesn't exist");
    return;
  }

  quoteSummary.items.splice(itemIndex, 1);
  const { totalPrice, totalItems } = getQuoteSummaryTotal(quoteSummary);
  quoteSummary.totalPrice = totalPrice;
  quoteSummary.totalItems = totalItems;

  dispatch({
    type: QUOTE_SUMMARY_UPDATE,
    payload: quoteSummary,
  });

  localStorage.setItem('quoteSummary', JSON.stringify(getState().quoteSummary));
};

export const updateQuoteSummaryItemQuantity = (quoteItemId, quantity) => (dispatch, getState) => {
  const quoteSummary = { ...getState().quoteSummary };
  quoteSummary.items = [...quoteSummary.items];

  const itemIndex = quoteSummary.items.findIndex((i) => i.id === quoteItemId);

  if (itemIndex < 0) {
    console.log("Quote item doesn't exist");
    return;
  }

  let quoteItem = { ...quoteSummary.items[itemIndex] };
  quoteItem.quantity = quantity;
  quoteItem.totalPrice = getQuoteSummaryItemTotal(quoteItem);
  quoteSummary.items[itemIndex] = quoteItem;

  const { totalPrice, totalItems } = getQuoteSummaryTotal(quoteSummary);
  quoteSummary.totalPrice = totalPrice;
  quoteSummary.totalItems = totalItems;

  dispatch({
    type: QUOTE_SUMMARY_UPDATE,
    payload: quoteSummary,
  });

  localStorage.setItem('quoteSummary', JSON.stringify(getState().quoteSummary));
};

const getQuoteSummaryTotal = (quoteSummary) => {
  let totalPrice = 0;
  let totalItems = 0;

  for (const quoteItem of quoteSummary.items) {
    totalPrice += getQuoteSummaryItemTotal(quoteItem);
    totalItems += quoteItem.quantity;
  }

  return { totalPrice, totalItems };
};

const getQuoteSummaryItemTotal = (quoteItem) => {
  const setup = quoteItem.item.customization.setup;

  const pricingTier = getPricingTier({
    quantity: quoteItem.quantity,
    tiers: quoteItem.item.pricingTiers,
    itemsPerCase: quoteItem.item.uom.conversion,
  });

  return pricingTier.rate * quoteItem.quantity + setup;
};

export const submitQuote = (quoteData) => async (dispatch) => {
  try {
    dispatch({ type: SUBMIT_QUOTE_REQUEST });

    withGreToken('submitQuote').then(async (greToken) => {
      axios
        .post(`/quote`, Object.assign({}, quoteData, { greToken }))
        .then(({ data }) => {
          dispatch({
            type: SUBMIT_QUOTE_SUCCESS,
            payload: { quoteId: data, email: quoteData.email },
          });


          zarazService.custom.formSubmit({
            formName: 'Custom Shop | Get A Quote',
            formAction: new URL('/quote', window.location.origin).toString(),
            submitText: 'Get Quote',
          });

          abtastyService.trackClick('Custom Shop: Get Quote');
        })
        .catch((error) => {
          dispatch({
            type: SUBMIT_QUOTE_FAIL,
            payload: error.response.data.message || 'Failed to submit quote, please try again later',
          });
        });
    });
  } catch (error) {
    dispatch({
      type: SUBMIT_QUOTE_FAIL,
      payload: error.response.data.message || 'Failed to submit quote, please try again later',
    });
  }
};
